<template>
  <div>
    <!-- 12911特殊标签打印 -->
    <div class="box">
      <p class="mb">{{ specialLabelData.client_remark }}</p>
      <img src="@/assets/icon/blatto.png" alt="">
      <h6>合同会社blatto</h6>
      <p class="mb" style="margin-top: 42px;">045-900-3264</p>
      <p class="mb">神奈川県横浜市山下町192</p>
      <h6>MADE IN CHINA</h6>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    specialLabelData: { type: Object },
  },
  data() {
    return {
    };
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
.box {
  padding: 50px 30px;
  background-color: #fff;

  margin: 20px;

  p {
    text-align: center;
    font-size: 22px;
  }

  .mb {
    margin-bottom: 30px;
  }

  img {
    margin: 80px 0 50px;
    width: 100%;
  }

  h6 {
    font-size: 28px;
    text-align: center;

    &:nth-last-child(1) {
      margin-top: 50px;
    }
  }
}
</style>